<template>
  <v-dialog persistent v-model="dialog.show" max-width="290">
    <v-card>
      <v-card-title class="subheading">{{ $vuetify.t('$vuetify.confirmDeleteTitle') }}</v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="default"
          flat
          @click.native="dialog.show = false"
          :disabled="loading"
        >{{ $vuetify.t('$vuetify.no') }}</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          flat
          @click.native="remove()"
        >{{ $vuetify.t('$vuetify.yes') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Object,
      default: function() {
        return { show: false, success: "" };
      }
    },
    route: {
      type: String,
      default: null
    }
  },
  data: () => ({
    loading: false
  }),
  methods: {
    remove: function() {
      if (!this.route) return false;

      let self = this;
      this.loading = true;
      this.$store
        .dispatch("request", {
          url: self.route,
          options: {
            method: 'DELETE'
          }
        })
        .then(() => {
          // refresh applications list
          self.$emit("refreshItems");
          // display message
          this.$store.dispatch("setNotification", {
            status: true,
            message: self.$vuetify.t(self.dialog.success)
          });
        })
        .catch(() => {
          this.$store.dispatch("setNotification", {
            status: true,
            message: self.$vuetify.t("$vuetify.errorOccured")
          });
        })
        .then(() => {
          this.loading = false;
          this.dialog.show = false;
        });
    }
  }
};
</script>